module.exports = __webpack_public_path__ + "static/img/k1.860a256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/k1.png
// module id = WMa3
// module chunks = 1